var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { watchImmediate } from "@vueuse/core";
import { BAlert } from "bootstrap-vue";
import { computed, ref } from "vue";
import Multiselect from "vue-multiselect";
import { GalaxyApi } from "@/api";
import {} from "@/api/schema";
import { errorMessageAsString } from "@/utils/simple-error";
import License from "@/components/License/License.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LicenseSelector',
    props: {
        inputLicense: null
    },
    emits: ["onLicense"],
    setup(__props, { emit }) {
        const props = __props;
        const defaultLicense = {
            licenseId: null,
            name: "*Do not specify a license.*",
        };
        const licensesLoading = ref(false);
        const errorMessage = ref("");
        const currentLicense = ref();
        const licenses = ref([]);
        const licenseOptions = computed(() => {
            var _a;
            const options = [];
            options.push(defaultLicense);
            for (const license of licenses.value || []) {
                if (license.licenseId == ((_a = currentLicense.value) === null || _a === void 0 ? void 0 : _a.licenseId) || license.recommended) {
                    options.push({
                        licenseId: license.licenseId,
                        name: license.name,
                    });
                }
            }
            return options;
        });
        function onLicense(license) {
            emit("onLicense", license.licenseId);
        }
        function fetchLicenses() {
            return __awaiter(this, void 0, void 0, function* () {
                const { error, data } = yield GalaxyApi().GET("/api/licenses");
                if (error) {
                    errorMessage.value = errorMessageAsString(error) || "Unable to fetch licenses.";
                }
                licenses.value = data;
                licensesLoading.value = false;
            });
        }
        function setCurrentLicense() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                if (!((_a = licenses.value) === null || _a === void 0 ? void 0 : _a.length) && !licensesLoading.value) {
                    licensesLoading.value = true;
                    yield fetchLicenses();
                }
                const inputLicense = props.inputLicense;
                currentLicense.value = (licenses.value || []).find((l) => l.licenseId == inputLicense) || defaultLicense;
            });
        }
        watchImmediate(() => props.inputLicense, () => {
            setCurrentLicense();
        });
        return { __sfc: true, defaultLicense, props, emit, licensesLoading, errorMessage, currentLicense, licenses, licenseOptions, onLicense, fetchLicenses, setCurrentLicense, BAlert, Multiselect, License, LoadingSpan };
    }
});
